import { Injectable } from '@angular/core';
import { ShowAlertModel } from '../show-alert/show-alert.model';
declare var $;
import { CustomModalPopUpModel } from './custom-modal-pop-up.model';
@Injectable()
export class CustomModalPopUpService {


      private customPopUps = new Set<CustomModalPopUpModel>();
      private AlertPopUp = new Set<ShowAlertModel>();
      constructor() {
      }

      _register(info: CustomModalPopUpModel): void {
            this.customPopUps.add(info);
            // console.log('CustomModalPopUpModel _register', this.customPopUps);
      }

      _unregister(info: CustomModalPopUpModel): void {
            this.customPopUps.forEach(item => {
                  if (item === info) {
                        this.customPopUps.delete(item);
                  }
            });
            // console.log('CustomModalPopUpModel _unregister', this.customPopUps);
      }

      showHideMe(val: boolean, id: string) {
            if (val) {
                  $(`#${id}`).modal('show');
            } else {
                  $(`#${id}`).modal('hide');
            }
      }


      show(info: CustomModalPopUpModel) {
            $(`#${info.id}`).modal('show');
      }

      hide(info: CustomModalPopUpModel) {
            $(`#${info.id}`).modal('hide');
      }




      //_____------------------____________------------------------__________----------------------------___________-------------------------------//

      _registerAlertModal(info: ShowAlertModel): void {
            this.AlertPopUp.add(info);
      }

      
      _unregisterAlertModal(info: ShowAlertModel): void {
            this.AlertPopUp.forEach(item => {
                  if (item === info) {
                        this.AlertPopUp.delete(item);
                  }
            });
      }

      showHideAlert(val: boolean, id: string) {
            if (val) {
                  $(`#${id}`).modal('show');
            } else {
                  $(`#${id}`).modal('hide');
            }
      }


      // showAlert(info: ShowAlertModel) {
      //       $(`#${info.id}`).modal('show');
      // }

      // hideAlert(info: ShowAlertModel) {
      //       $(`#${info.id}`).modal('hide');
      // }

}